import { render, staticRenderFns } from "./MobileUnavailableItems.vue?vue&type=template&id=6d5421b7&"
import script from "./MobileUnavailableItems.vue?vue&type=script&lang=js&"
export * from "./MobileUnavailableItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports